import React, { Component } from 'react'
import FormControl from 'react-bootstrap/lib/FormControl'
import { ExpiredTrialAlertWindow } from "./alert_window"
import { makeToast } from '../util/toast_util'
import { appConsts } from '../common/constants/app_consts'
import { checkIfEmailIsValid } from '../util/onboarding_utils'
import { appStrings } from '../common/strings/app_strings'

const { validEmail } = appStrings.teamModalSearch

class TeamModalSearch extends Component {
    constructor(props) {
        super(props)

        this.handleChange = this.handleChange.bind(this)
        this.onAdd = this.onAdd.bind(this)
        this.state = {
            value: '',
            showAlertModal: false,
        }
    }

    handleChange(event) {
        if (event && event.target) {
            this.setState({value: event.target.value})
        }
    }

    hideAlertModal = () => {
        this.setState({ showAlertModal: false })
    }

    openUpgradeModal = () => {
        this.setState({ showAlertModal: false }, () => {
            this.props.setPaymentModalOpen(true)
        })
    }

    onAdd() {
        const { createInvite, team, trialEnd } = this.props
        const { value: invitedEmail = "" } = this.state
        
        if (!invitedEmail.trim() || !checkIfEmailIsValid(invitedEmail, appConsts.regExEmailValidation)) {
            makeToast(validEmail, "warning")
            return
        }

        const accountIsExpired = trialEnd && new Date(trialEnd) < new Date()
        if (accountIsExpired) {
            this.setState({ showAlertModal: true })
            return
        }

        const invite = {
            teamId: team.id,
            invitedEmail: invitedEmail,
            role: 'Member',
        }
        createInvite(invite)

        this.setState({
            value: '',
        })
    }

    render() {
        const { userId, team } = this.props
        return (
            <div className="team-search">
                <ExpiredTrialAlertWindow
                    isOpen={this.state.showAlertModal}
                    handleCloseAlert={this.hideAlertModal}
                    team={team}
                    accountName={""}
                    type="TEAM_INVITE"
                    upgrade={this.openUpgradeModal}
                    personalTeamId={""}
                    userId={userId}
                />
                <div className="team-search-form">
                    <FormControl
                        type="text"
                        value={this.state.value}
                        placeholder="Add member by email"
                        onChange={this.handleChange}
                    />
                    <button className="btn btn-primary btn-md btn-save team-search-btn team-modal-btn" type="button" onClick={this.onAdd}>Add</button>
                </div>
            </div>
        )
    }
}

export default TeamModalSearch



// WEBPACK FOOTER //
// ./src/components/team_modal_search.jsx